import articles from './articles';
import brands from './brands';
import categories from './categories';

export default [articles, brands, categories];
